/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesProfileGetTwitchData, FxIdWebFeaturesProfileGetTwitchDataFromJSONTyped, FxIdWebFeaturesProfileGetTwitchDataToJSON, } from './FxIdWebFeaturesProfileGetTwitchData';
export function FxIdWebFeaturesProfileGetResponseTwitchFromJSON(json) {
    return FxIdWebFeaturesProfileGetResponseTwitchFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseTwitchFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesProfileGetTwitchData(json)) {
        return FxIdWebFeaturesProfileGetTwitchDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesProfileGetResponseTwitchToJSON(json) {
    return FxIdWebFeaturesProfileGetResponseTwitchToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseTwitchToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesProfileGetTwitchData(value)) {
        return FxIdWebFeaturesProfileGetTwitchDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesProfileGetResponseTwitch.js.map